import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { URLserver } from '../services/urlServer';
import axios from 'axios';
import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import { apiService } from '../services/apiService';


const TablaInventario = ({ productos, getProductos, toast }) => {
    const [globalFilter, setGlobalFilter] = useState(null);

    const FormatearFecha = (fechaISO) => {
        if (!fechaISO) return ''; // Validar que exista la fecha
        
        const fecha = new Date(fechaISO);
        
        // Formatear fecha en dd/mm/yyyy
        const fechaFormateada = fecha.toLocaleDateString('es-ES', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
        
        // Formatear hora en hh:mm
        const horaFormateada = fecha.toLocaleTimeString('es-ES', {
            hour: '2-digit',
            minute: '2-digit'
        });
    
        return `${fechaFormateada} ${horaFormateada}`;
    };

    

    const eliminarProducto = async (id) => {
        try {
            const response = await apiService.deleteData(`productos/${id}/`);
            toast.current.show({severity:'success', summary: 'Solicitud Exitosa', detail:'Producto eliminado exitosamente!', life: 2000});
            getProductos(); // Llamar a la función para actualizar la lista de productos
        } catch (error) {
            console.error("Error al eliminar el producto", error);
        }
    };

    const confirmarEliminacion = (producto) => {
        confirmDialog({
            message: `¿Estás seguro de que deseas eliminar "${producto.nombre}"?`,
            header: 'Confirmación de Eliminación',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: "Eliminar",
            rejectLabel: "Cancelar",
            acceptClassName: "p-button-danger",
            accept: () => eliminarProducto(producto.id),
            reject: () => console.log('Eliminación cancelada')
        });
    };

    const accionesTemplate = (rowData) => {
        return (
            <Button 
                icon="pi pi-trash" 
                className="p-button-rounded p-button-danger p-button-sm" 
                onClick={() => confirmarEliminacion(rowData)}
                tooltip="Eliminar"
            />
        );
    };

    return (
        <div className="datatable-filter-demo">
            <div className="col-6 p-inputgroup" style={{ marginBottom: '1rem' }}>
                <span className="p-inputgroup-addon">
                    <i className="pi pi-search" />
                </span>
                <InputText 
                    type="search" 
                    onInput={(e) => setGlobalFilter(e.target.value)} 
                    placeholder="Buscar producto..." 
                />
            </div>

            <DataTable value={productos} globalFilter={globalFilter}>
                <Column field="codigo" header="Codigo" style={{ textAlign:"center", fontSize:"15px"}} alignHeader={"center"} headerClassName='header-table-style'></Column>
                <Column field="categoria_nombre" header="Categoria" style={{ textAlign:"center", fontSize:"15px"}} alignHeader={"center"} headerClassName='header-table-style'></Column>
                <Column field="nombre" header="Nombre" style={{ textAlign:"center", fontSize:"15px"}} alignHeader={"center"} headerClassName='header-table-style'></Column>
                <Column field="proveedor_nombre" header="Proveedor" style={{ textAlign:"center", fontSize:"15px"}} alignHeader={"center"} headerClassName='header-table-style'></Column>
                <Column field="cantidad_disponible" header="Cant. Disponible" style={{ textAlign:"center", fontSize:"15px"}} alignHeader={"center"} headerClassName='header-table-style'></Column>
                <Column field="precio_producto" header="Precio Venta" style={{ textAlign:"center", fontSize:"15px"}} alignHeader={"center"} headerClassName='header-table-style'></Column>
                <Column 
                    field="ult_actualizacion_precio" 
                    header="Ult. Act. Precio" 
                    style={{ textAlign: "center", fontSize:"15px" }} 
                    alignHeader="center" 
                    headerClassName="header-table-style"
                    body={(rowData) => FormatearFecha(rowData.ult_actualizacion_precio)} // Aquí se formatea la fecha
                />
                <Column 
                    header="Acciones" 
                    style={{ textAlign:"center", fontSize:"15px"}} 
                    headerClassName='header-table-style'
                    alignHeader={"center"} 
                    body={accionesTemplate} 
                />            
            </DataTable>
        </div>
    );
};

export default TablaInventario;
